export default "__VITE_ASSET__97822264__"